<template>
  <v-dialog lazy v-model="opened" max-width="256px">
    <v-avatar slot="activator" class="elevation-2 mr-3">
      <img :src="src" />
    </v-avatar>

    <!-- Avatar Upload Dialog -->
    <v-card dark>
      <v-card-title class="headline">Upload Avatar</v-card-title>
      <v-divider />
      <v-img height="256px" :src="image && preview ? preview : src">
        <v-container fill-height>
          <v-layout column align-center justify-top>
            <v-btn color="primary" @click.native="$refs.file.click()">
              Click to Upload
            </v-btn>
          </v-layout>
        </v-container>
        <input type="file" name="file" ref="file" @change="setFile" style="display: none;" />
      </v-img>
      <v-card-actions><v-spacer />
        <v-btn color="grey" flat @click="opened = false">cancel</v-btn>
        <v-btn color="secondary" @click="submit">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Vue Component
export default {
  props: { src: String, path: String },
  data() {
    return {
      opened: false,
      image: null,
      preview: null,
    }
  },
  methods: {
    setFile() {
      this.image = this.$refs.file.files[0]
      const reader = new FileReader()
      reader.addEventListener('load', () => (this.preview = reader.result), false)
      if (this.image) reader.readAsDataURL(this.image)
    },
    submit() {
      if (this.image) {
        let formData = new FormData()
        formData.append('avatar', this.image)
        this.$http
          .post(this.path, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then(() => this.$emit('success'))
          .then(() => (this.opened = false))
      }
    },
  },
}
</script>
